import { Button } from '@amzn/awsui-components-react-v3';

const iconMap = {
  expand: 'treeview-expand',
  collapse: 'treeview-collapse',
};

export default class ExpandButton extends React.Component {
  render() {
    const { status, onClick, loading } = this.props;

    return (
      <Button
        variant="icon"
        iconName={iconMap[status] || iconMap.collapse}
        onClick={onClick}
        className="awsui-util-mt-xs"
        loading={loading || false}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/expand_button.js